import { GlobalProvider } from '@context/Global/GlobalProvider';
import 'antd/dist/antd.min.css';
import * as onScan from 'onscan.js';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import App from './App';
import { RETRY, WINDOW_FOCUS_REFETCH } from './constants/useQueryOption_';
import './index.scss';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: RETRY,
            refetchOnWindowFocus: WINDOW_FOCUS_REFETCH,
        },
    },
});
(onScan as any).attachTo(document);
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <GlobalProvider>
        <QueryClientProvider client={queryClient}>
            <Suspense fallback={false}>
                <App />
            </Suspense>
            <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        </QueryClientProvider>
    </GlobalProvider>,
);
